/* eslint-disable react-hooks/exhaustive-deps */
import { ClearableSearchField } from "components/SearchField/SearchField";
import HelpIcon from "@mui/icons-material/Help";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { fetchContacts, fetchInvoiceReminderLogs } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
const pdfStyle = {
  boxShadow: 24,
  p: 4,
  top: "50%",
  left: "50%",
  width: "90%",
  height: "90%x",
  position: "absolute",
  border: "2px solid #000",
  bgcolor: "background.paper",
  transform: "translate(-50%, -50%)",
};

const SCREEN_NAME = "Invoice Reminder Logs";
let SCREEN_RIGHT;
function InvoiceReminderLogs() {
  let currency = useSelector((state) => state.currency.currencySymbol);
  const [rows, setRows] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [tabledata, setTableData] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [resetClicked, setResetClicked] = useState(false);
  const dispatch = useDispatch();
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [contact, setContact] = useState([]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState("");
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [screenAccess, setScreenAccess] = useState(false);

  const [values, setValues] = useState({
    reminderDuration: "",
    sortingType: "",
    sortingField: "",
    reminderType: "All",
    contactName: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
    customTo: new Date(),
    searchParameterList: [
      "invoiceDateString",
      "dueDateString",
      "reminderDateTime",
      "reminderType",
      "reminderTemplateName",
      "invoiceNumber",
      "dueDate",
      "invoiceDate",
      "contactName",
      "invoiceAmount",
      "reminderDuration",
    ],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });

  const headers = [
    { label: "Reminder Date Time", key: "reminderDateTime" },
    { label: "Reminder Type", key: "reminderType" },
    { label: "Reminder Template Name", key: "reminderTemplateName" },
    { label: "Invoice Number", key: "invoiceNumber" },
    { label: "Invoice Date", key: "invoiceDate" },
    { label: "Due Date", key: "dueDate" },
    { label: "Contact Name", key: "contactName" },
    { label: "Invoice Amount", key: "invoiceAmount" },
    { label: "Email Status", key: "emailSendStatus" },
    { label: "Legal Document", key: "documentFileName" },
  ];

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchInvoiceReminderLog();
      await fetchContact();
    })();
  }, [values.sortingType, perPage, dispatch]);

  useEffect(() => {
    if (resetClicked) {
      const fetchdata = async () => {
        setResetClicked(false);
        await getRight();
        await fetchInvoiceReminderLog();
      };
      fetchdata();
    }
  }, [resetClicked]);

  async function getRight() {
    SCREEN_RIGHT = await getScreenRight(SCREEN_NAME);
    console.log("SCREEN_RIGHT", SCREEN_RIGHT);
    setScreenAccess(SCREEN_RIGHT === "Full Access");
  }

  const FilterData = async () => {
    await fetchInvoiceReminderLogs(
      {
        reminderDuration: values.reminderDuration,
        reminderType: values.reminderType,
        contactName: values.contactName,
        businessUserID: values.businessUserID,
        page: appConstants.page,
        limit: appConstants.limit,
        sortingType: "",
        sortingField: "",
        customFrom: values.customFrom,
        customTo: values.customTo,
      },
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
        setTableData(data.Result_Output.docs);
      },
      dispatch
    );
  };

  const ResetData = async () => {
    setValues({
      ...values,
      searchParameter: "",
      reminderDuration: "",
      reminderType: "All",
      contactName: "All",
      page: appConstants.page,
      limit: appConstants.limit,
      sortingType: "",
      sortingField: "",
      filterValues: "",
    });
    setResetClicked(true);
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };
  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };
  const handlePageChange = (page) => {
    values.page = page;
    fetchInvoiceReminderLog();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    await fetchInvoiceReminderLog();
  };

  function exportSwal() {
    setShowModel(false);
    showResMsg(genericMessage.dataExportedSucces, 1000, true);
  }

  const fetchInvoiceReminderLog = async () => {
    await fetchInvoiceReminderLogs(
      values,
      (data) => {
        console.log("data", data);
        setTotalRows(data.result.Result_Output.totalDocs);
        setRows(data.result.Result_Output.docs);
        setTableData(data.result.export);
        console.log("data", data);
      },
      dispatch
    );
  };

  //contacts
  const fetchContact = async () => {
    await fetchContacts(
      values,
      (data) => {
        setContact(data.Result_Output);
      },
      dispatch
    );
  };
  const handleDateChange = (name) => (date) => {
    setValues({ ...values, [name]: new Date(date) });
  };

  const handleViewDocument = (filePath) => {
    setSetDocumentFileURL(
      appConstants.baseURL +
        "invoiceReminderLogs/viewSentLegalDocument?fileName=/" +
        filePath
    );
    setViewDocumentInModal(true);
  };

  // Give theme color to hide filter --- Starts here

  const { tableBorder } = getColorMappings(sidenavColor);
  // var element = document.getElementsByTagName('fieldset');
  // useEffect(() => {
  //   for (let i = 0; i < element.length; i++) {

  //     if (darkMode) {
  //       element[i].style.borderColor = "white";
  //     } else {
  //       element[i].style.borderColor = tableBorder;
  //     }

  //   }
  // }, [showFilters])

  useEffect(() => {
    var element = document.getElementsByTagName("fieldset");
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    for (let i = 0; i < element.length; i++) {
      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;
    }
  }, [showFilters]);

  useEffect(() => {
    var dropicons = document.querySelectorAll(".MuiInputBase-root");
    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName("svg");
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "fill: black !important;");
        }
      }
    }
  }, [showFilters]);

  //Ends here
  const reportCol = [
    {
      name: (
        <p style={{ textAlign: "center", fontSize: "12px" }}>
          Reminder Date Time
        </p>
      ),
      selector: (row) => row.reminderDuration,
      sortable: true,
      sortField: "reminderDuration",
      style: { textAlign: "center" },
    },
    {
      // name: "Reminder Type",
      name: (
        <p style={{ paddingLeft: "25px", fontSize: "12px" }}>Reminder Type</p>
      ),
      selector: (row) => row.reminderType,
      sortable: true,
      sortField: "reminderType",
      center: true,
    },

    {
      // name: "Reminder Template Name",
      name: (
        <p style={{ paddingLeft: "12px", fontSize: "12px" }}>
          Reminder Template Name
        </p>
      ),
      selector: (row) => row.reminderTemplateName,
      sortable: true,
      sortField: "reminderTemplateName",
      center: true,
    },
    {
      // name: "Invoice Number",
      name: (
        <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Invoice Number</p>
      ),
      selector: (row) => row.invoiceNumber,
      sortable: true,
      sortField: "invoiceNumber",
      center: true,
    },
    {
      // name: "Invoice Date",
      name: (
        <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Invoice Date</p>
      ),
      selector: (row) => row.invoiceDateString,
      sortable: true,
      sortField: "invoiceDate",
      center: true,
    },
    {
      name: <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Due Date</p>,
      selector: (row) => row.dueDateString,
      sortable: true,
      sortField: "dueDate",
      center: true,
    },
    {
      // name: "Contact Name",
      name: (
        <p
          style={{ paddingLeft: "12px", fontSize: "12px", textAlign: "center" }}
        >
          Contact Name
        </p>
      ),
      selector: (row) => row.contactName,
      sortable: true,
      style: { textAlign: "center" },
      sortField: "contactName",
      center: true,
    },
    {
      // name: `Amount (${currency})`,
      name: (
        <p
          style={{ paddingLeft: "12px", fontSize: "12px" }}
        >{`Amount (${currency})`}</p>
      ),
      selector: (row) => row.invoiceAmount,
      sortable: true,
      sortField: "invoiceAmount",
      center: true,
    },
    {
      // name: "Email Status",
      name: (
        <p style={{ paddingLeft: "12px", fontSize: "12px" }}>Email Status</p>
      ),
      selector: (row) => row.emailSendStatus,
      sortable: true,
      sortField: "emailSendStatus",
      center: true,
    },
    {
      // name: "Legal Document",
      name: <p style={{ fontSize: "12px" }}>Legal Document</p>,
      selector: (row) => row,
      center: true,
      cell: (row) => (
        <>
          {row.documentFileName === "FAILED_TO_UPLOAD" ? (
            <span>FAILED TO SEND</span>
          ) : row.documentFileName === "WITHOUT_DOCUMENT" ? (
            <span>NO DATA.</span>
          ) : (
            <Grid
              container
              justifyContent={"center"}
              mr={2}
              spacing={4}
              mt={-6.2}
            >
              <Grid item>
                <TimelineItem
                  color="info"
                  icon="visibility"
                  onClick={() => {
                    handleViewDocument(row.documentFileName);
                  }}
                  title="View"
                  disabled={!screenAccess}
                />
              </Grid>
            </Grid>
          )}
        </>
      ),
    },
  ];

  let contactName =
    contact.length > 0 &&
    contact.map((item, i) => {
      return (
        <MenuItem key={i} value={item.name}>
          {item.name}
        </MenuItem>
      );
    }, this);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Invoice Reminder Logs" />
          <Grid
            container
            columnSpacing={2}
            px={2}
            mt={3}
            mb={2}
            alignItems="center"
            display="flex"
            justifyContent="right"
          >
            {/* <Grid item xs={12} mt={2} mb={2} spacing={2} lg={1.4} >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                color={"secondary"}
                fullWidth
                onClick={() => { setShowFilters(!showFilters) }}
                style={{ minWidth: "99px", width: "99px", height: "10px", padding: "0px 10px" }}
              >
                {showFilters ? 'Hide Filters' : 'Set Filters'}

              </MDButton>
            </Grid>
            <Grid item xs={12} mt={2} mb={2} spacing={2} lg={1.4} pr={.8} >
              <MDButton
                className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                style={{ backgroundColor: "#009cff", color: "#ffffff", minWidth: "99px", width: "99px", height: "10px", padding: "0px 10px" }}
                fullWidth
                onClick={() => { setShowModel(true) }}
              >
                Export
              </MDButton>
            </Grid> */}
            <Grid item xs={12} md={6} lg={9.2}>
              {values.reminderDuration === "Custom" && (
                <Grid
                  container
                  spacing={1.6}
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    paddingLeft: "10px",
                  }}
                >
                  <Grid item xs={6} lg={1.5}>
                    <PickDate
                      selected={new Date(values.customFrom)}
                      onChange={handleDateChange("customFrom")}
                      label="From"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      maxDate={
                        new Date(new Date().setDate(new Date().getDate() - 1))
                      }
                    />
                  </Grid>
                  <Grid item xs={6} lg={1.5}>
                    <PickDate
                      selected={new Date(values.customTo)}
                      onChange={handleDateChange("customTo")}
                      label="To"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      maxDate={new Date()}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.4}>
              <MDButton
                className={
                  "btn-block center-container-btn btn-warning btn-back rightSpace"
                }
                color={"warning"}
                fullWidth
                onClick={() => {
                  setShowFilters(!showFilters);
                }}
                style={{ height: "38.11px" }}
              >
                {showFilters ? "Hide Filters" : "Set Filters"}
              </MDButton>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.4}>
              {screenAccess ? (
                <MDButton
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  // color={disableColor ? "secondary" : "success"}
                  // fullWidth
                  // onClick={disableColor ? blank : () => { setShowModel(true) }}
                  // color={"primary"}
                  style={{
                    backgroundColor: "#009cff",
                    color: "#ffffff",
                    height: "38.11px",
                  }}
                  fullWidth
                  onClick={() => {
                    setShowModel(true);
                  }}
                >
                  Export
                </MDButton>
              ) : (
                <MDButton
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  style={{ height: "38.11px" }}
                  color={"secondary"}
                  fullWidth
                >
                  Export
                </MDButton>
              )}
            </Grid>
          </Grid>
          {showFilters && (
            <MDBox>
              <Grid item xs={12}>
                <MDBox px={1} pt={1}>
                  <Grid container columnSpacing={2} mx={0.1}>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="reminderDuration">
                            Reminder Duration
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "38.11px" }}
                            label="Reminder Duration"
                            value={values.reminderDuration}
                            onChange={handleChange("reminderDuration")}
                          >
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="last7Days"> Last 7 Days </MenuItem>
                            <MenuItem value="last30Days">
                              {" "}
                              Last 30 Days{" "}
                            </MenuItem>
                            <MenuItem value="last1Year">
                              {" "}
                              Last 12 Month{" "}
                            </MenuItem>
                            <MenuItem value="Custom"> Custom Date</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="reminderType">
                            Reminder Type
                          </InputLabel>
                          <Select
                            labelId="reminderType-select-label"
                            id="reminderType-select"
                            style={{ minHeight: "38.11px" }}
                            label="Reminder Type"
                            value={values.reminderType}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                reminderType: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="All">All</MenuItem>
                            <MenuItem value="Due In">Due In</MenuItem>
                            <MenuItem value="Overdue By">Overdue By</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="contactName">Contact Name</InputLabel>
                          <Select
                            labelId="contactName-select-label"
                            id="contactName-select"
                            style={{ minHeight: "38.11px" }}
                            label="Contact Name"
                            value={values.contactName}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                contactName: e.target.value,
                              })
                            }
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 34 * 10,
                                },
                              },
                            }}
                          >
                            {contactName}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2.3}>
                      <ClearableSearchField
                        type="text"
                        label="Search"
                        variant="outlined"
                        fullWidth
                        className="searchButton"
                        placeholder="Search..."
                        size="medium"
                        value={values.filterValues}
                        onChange={handleSearchFilter}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") fetchInvoiceReminderLog();
                        }}
                        InputProps={{
                          shrink: true,
                          endAdornment: (
                            <InputAdornment>
                              <Button
                                style={{
                                  borderRadius: "0px 0.3rem  0.3rem 0px",
                                  boxShadow: "none",
                                  background: barColor,
                                }}
                                variant="contained"
                                onClick={fetchInvoiceReminderLog}
                              >
                                <GridSearchIcon color="white" />
                              </Button>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    {/* <Grid item xs={12} my={0.5} spacing={2} lg={1}>
                      <MDButton
                        className="btn-block center-container-btn btn-warning btn-back rightSpace"
                        color="warning"

                        onClick={ResetData}
                        style={{ minWidth: "99px", height:"44px" }}
                      >
                        Reset
                      </MDButton>
                    </Grid>
                    <Grid item xs={12} my={0.5} spacing={2} lg={1}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"

                        onClick={FilterData}
                        style={{ minWidth: "99px",height:"44px" }}
                      >Apply
                      </MDButton>
                    </Grid> */}

                    <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                      <MDButton
                        className="btn-block center-container-btn btn-warning btn-back rightSpace"
                        color="warning"
                        fullWidth
                        onClick={ResetData}
                        style={{ height: "38.11px" }}
                      >
                        Reset
                      </MDButton>
                    </Grid>
                    <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                        onClick={FilterData}
                        style={{ height: "38.11px" }}
                      >
                        Apply
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </MDBox>
          )}
          {/* <CardContent> */}
          <BTable
            columns={reportCol}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>

        {showModel && (
          <Modal
            open={showModel}
            onClose={() => setShowModel(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ fontSize: "40px", textAlign: "center" }}
                >
                  <HelpIcon style={{ color: "red" }} />
                </Typography>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ color: "black" }}
                >
                  Would you like to export this record?
                </Typography>
                <Grid
                  container
                  id="modal-modal-description"
                  sx={{ mt: 2, justifyContent: "center" }}
                >
                  <>
                    <MDButton
                      className="no-button"
                      onClick={() => {
                        setShowModel(false);
                      }}
                      sx={{ width: "64px", textTransform: "capitalize" }}
                    >
                      No
                    </MDButton>
                  </>
                  &nbsp; &nbsp;
                  <>
                    <CSVLink
                      data={tabledata}
                      headers={headers}
                      filename={
                        "Invoice Reminder Logs (" +
                        new Date().toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        }) +
                        ") .csv"
                      }
                    >
                      <MDButton
                        className="yes-button"
                        onClick={() => {
                          exportSwal();
                        }}
                        sx={{ width: "64px", textTransform: "capitalize" }}
                      >
                        Yes
                      </MDButton>
                    </CSVLink>
                  </>
                </Grid>
              </Box>
            </Card>
          </Modal>
        )}

        <Modal
          className="document-preview-overlay"
          open={viewDocumentInModal}
          onClose={() => setViewDocumentInModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            "& .MuiModal-root": {
              width: "100%",
              height: "100%",
            },
          }}
        >
          <Card sx={pdfStyle}>
            <Box>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Document Viewer
              </Typography>
              <iframe
                title="Document Viewer"
                src={getDocumentFileURL}
                width="100%"
                height="650"
                frameborder="0"
                allowfullscreen={true}
              ></iframe>
              {/* <iframe title="Document Viewer" src="C:/boss_invoice/invoice_images/InvoiceReminderAttachment/650d804268629a0a7c604c91/662f4f24716f7924a80ef806/Sample Template_INV-0003_2058_1714449398248.pdf" width="100%" height="650" frameborder="0" allowfullscreen={true}></iframe> */}

              <Grid
                container
                id="modal-modal-description"
                sx={{ mt: 2, justifyContent: "center" }}
              >
                <MDButton
                  color="warning"
                  className="modalButton"
                  onClick={() => {
                    setViewDocumentInModal(false);
                  }}
                >
                  Close
                </MDButton>
              </Grid>
            </Box>
          </Card>
        </Modal>
      </div>
    </DashboardLayout>
  );
}
export default InvoiceReminderLogs;
